import { pushToDataLayer } from '../datalayer';
import type { CloudRetailProductDetail } from './trackSearchResults';

export type TrackViewCategoryPageParams = {
  offset?: number;
  sortOrder?: string;
  cloudRetail?: {
    productDetails: Array<CloudRetailProductDetail>;
    filter?: string | null;
    attributionToken?: string | null;
    pageCategories?: Array<string> | null;
  };
};

export const trackViewCategoryPage = ({ offset, sortOrder, cloudRetail }: TrackViewCategoryPageParams) => {
  pushToDataLayer({
    event: 'view_category_page',
    offset,
    sort_order: sortOrder,
    ...(cloudRetail && {
      cloud_retail: {
        productDetails: cloudRetail.productDetails,
        filter: cloudRetail.filter,
        attributionToken: cloudRetail.attributionToken,
        pageCategories: cloudRetail.pageCategories,
      },
    }),
  });
};
